<template>
  <div>
    <h3 class="title">検索条件</h3>
    <ValidationObserver ref="observer" tag="form">
      <table class="table">
        <tbody>
          <tr>
            <td>企業コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="numeric|digits:16">
                <input id="enterpriseCode" :name="itemName.enterpriseCode" type="text" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="enterpriseCode" :readonly="isReadonly('enterpriseCode')" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>拠点コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="alpha_num|max:16">
                <input id="sectionCode" :name="itemName.sectionCode" type="text" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="sectionCode" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
        </tbody>
      </table>
    </ValidationObserver>
    <RfidButton :display="'inline'" @handleClick="search">検索</RfidButton>
    <router-link :to="{ name: 'section-edit-new', params: { mode: 'entry' }}" class="btn btn-primary btn-lg w200"
      role="button" aria-pressed="true" v-if="isDisplay('newCreate')">
      新規追加
    </router-link>
    <RfidButton :display="'inlinea'" v-if="isDisplay('csvOutput')" @handleClick="sectionDownload">CSV出力</RfidButton>
    <br><br>
  </div>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'section-search-window',

  components: {
    ValidationObserver,
    ValidationProvider,
    RfidButton
  },

  data () {
    return {
      enterpriseCode: '',
      sectionCode: '',
      permissionData: {},
      itemName: {}
    }
  },

  created () {
    this.permissionData = this.permission().sectionList['entry']
    this.itemName = this.item()
    if (this.$session.get('userDiv') === 1) {
      this.enterpriseCode = this.$session.get('enterpriseCode')
    }
  },

  methods: {
    isReadonly (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    isDisplay (item) {
      return this.permissionData[item][this.$session.get('userDiv')] !== 'displayNone'
    },
    async search () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('search', this.enterpriseCode, this.sectionCode)
    },
    async sectionDownload () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('sectionDownload', this.enterpriseCode, this.sectionCode)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/SectionSearchWindow.vue